'use client'
import classNames from 'classnames'
import { Heading, Icon, LinkButton } from 'design-system/client'
import { type ReactNode, useCallback } from 'react'
import { useTranslations } from 'next-intl'
import { useStep } from '../StepProvider'
import styles from './IFrameHeader.module.css'
import { postMessageScrollTop } from '@/helpers/utils'

// eslint-disable-next-line import/exports-last
export function IFrameHeaderContainer({
  headline,
  children,
  counter,
}: {
  headline: string
  children?: ReactNode
  counter?: ReactNode
}) {
  return (
    <header className={classNames('donate-iframe-header', styles.iFrameHeader)}>
      <div className={classNames('donate-iframe-header-wrapper', styles.iFrameHeaderInnerContainer)}>
        <div className={styles.headline}>
          {children}
          <div className={styles.headingContainer}>
            <Heading as="h1" level="heading-xs">
              {headline}
            </Heading>
            {counter}
          </div>
          {children && <div className={styles.column}>&nbsp;</div>}
        </div>
      </div>
    </header>
  )
}

function IFrameHeader() {
  const { step, setStep } = useStep()
  const goBack: React.MouseEventHandler = useCallback(
    (event) => {
      event.preventDefault()
      postMessageScrollTop()
      setStep(1)
    },
    [setStep]
  )

  const t = useTranslations('nextjs.donate.iframe')

  return (
    <IFrameHeaderContainer headline={t('headline')} counter={<p className="line2">({step}/2)</p>}>
      <div className={styles.column}>
        {step === 2 ? (
          <LinkButton onClick={goBack} className={styles.backButton} kind="onColor">
            <Icon name="chevronLeft" />
            {t('back_link')}
          </LinkButton>
        ) : (
          <>&nbsp;</>
        )}
      </div>
    </IFrameHeaderContainer>
  )
}

export default IFrameHeader
